/* eslint-disable no-param-reassign */
import { v1 as uuid } from 'uuid';
import * as types from './mutationTypes';

export default {
  [types.START_FETCH_AGENTS](state, query) {
    if (query) {
      state.query = {
        ...query,
      };
    }
    state.page = 1;
    state.agentCount = 0;
    state.isFetching = true;
    state.isFetched = false;
    state.isFetchedDefault = false;
    state.isFetchEnd = false;
    state.error = null;
    state.agents = [];
    state.sAgent = null;
    state.fetchId = uuid();
  },

  [types.SET_FETCHED_AGENTS](state, fetchedData) {
    state.isFetching = false;
    state.isFetched = true;
    state.isFetchedDefault = true;
    state.error = null;
    state.agents = fetchedData.result;
    if (fetchedData.count &&
      fetchedData.result.length === fetchedData.count) {
      state.isFetchEnd = true;
    }
  },

  [types.SET_FETCHED_AGENT_COUNT](state, count) {
    state.agentCount = count;
  },

  [types.FETCH_AGENTS_ERROR](state, error) {
    state.isFetching = false;
    state.isFetched = false;
    state.error = error;
    state.agents = [];
  },

  [types.START_FETCH_MORE_AGENTS](state) {
    state.page += 1;
    state.isFetching = true;
    state.isFetched = false;
    state.isFetchEnd = false;
    state.fetchError = null;
    state.isEmpty = false;
    state.fetchId = uuid();
  },

  [types.APPEND_FETCHED_AGENTS](state, fetchedAgents) {
    state.isFetching = false;
    state.isFetched = true;
    state.isEmpty = false;
    state.agents = state.agents.concat(fetchedAgents);
  },

  [types.FETCH_ENDED](state) {
    state.isFetching = false;
    state.isFetched = true;
    state.isFetchEnd = true;
  },

  [types.FETCHED_AGENT](state, fetchedAgent) {
    state.isFetching = false;
    state.isFetched = true;
    state.sAgent = fetchedAgent;
  },

  [types.SET_FILTER](state, filter) {
    const filters = { ...state.filters, ...filter };
    state.filters = filters;
  },

  [types.UNSET_FILTER](state, filterKey) {
    const filters = {
      ...state.filters,
    };
    delete filters[filterKey];
    state.filters = filters;
    state.selectedAgent = null;
  },

  [types.SET_ICS_TYPE](state, icsType) {
    state.icsType = icsType;
  },

  [types.SET_PAGE](state, page) {
    state.page = page;
    state.agents = [];
  },
};
